import { combineReducers } from 'redux'
import detail from './detail'
import status from './status'

export default combineReducers({
  detail,
  status,
})
